import apiCall from '../../index'

const apiService = '/api-erppalmas/api/v1/reclutamiento/ficha_reclutamiento'

const service = {
  findAll(params) {
    const query = `?etapa=${params.etapa}&idUsuario=${params.idUsuario}&limit=${params.limit}&page=${params.page}&sortBy=${params.sortBy}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    return new Promise((resolve, reject) => {
      apiCall
        .post(apiService, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update(model) {
    return new Promise((resolve, reject) => {
      apiCall
        .put(apiService, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  updateEtapa(params) {
    const query = `/update_etapa?etapa=${params.etapa}&idFichaReclutamiento=${params.idFichaReclutamiento}`
    return new Promise((resolve, reject) => {
      apiCall
        .put(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    return new Promise((resolve, reject) => {
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
